var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.1;}\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{opacity:0.1;fill:#A20C33;}\n\t.st4{fill:#A20C33;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,6.7c-2.1-2.1-5.6-2.1-7.8,0c0,0,0,0,0,0L14,7.7l-1.1-1.1c-2.1-2.1-5.6-2.1-7.8,0s-2.1,5.6,0,7.8l1.1,1.1 l7.8,7.8l7.8-7.8l1.1-1.1C24.9,12.3,24.9,8.8,22.8,6.7C22.8,6.7,22.8,6.7,22.8,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.8,4.6c-2.1-2.1-5.6-2.1-7.8,0c0,0,0,0,0,0L12,5.7l-1.1-1.1c-2.1-2.1-5.6-2.1-7.8,0s-2.1,5.6,0,7.8l1.1,1.1 l7.8,7.8l7.8-7.8l1.1-1.1C23,10.2,23,6.8,20.8,4.6C20.8,4.6,20.8,4.6,20.8,4.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,6.7c-2.1-2.1-5.6-2.1-7.8,0c0,0,0,0,0,0L14,7.7l-1.1-1.1c-2.1-2.1-5.6-2.1-7.8,0s-2.1,5.6,0,7.8l1.1,1.1 l7.8,7.8l7.8-7.8l1.1-1.1C24.9,12.3,24.9,8.8,22.8,6.7C22.8,6.7,22.8,6.7,22.8,6.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12,21.9c-0.2,0-0.3-0.1-0.5-0.2l-8.8-8.8c-1.2-1.2-1.8-2.7-1.8-4.4s0.6-3.2,1.8-4.3c2.4-2.4,6.3-2.4,8.7,0 L12,4.8l0.6-0.6c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7l-8.8,8.8C12.3,21.8,12.2,21.9,12,21.9z M7,3.7 c-1.2,0-2.5,0.5-3.4,1.4C2.7,6,2.2,7.2,2.2,8.5s0.5,2.5,1.4,3.4l8.4,8.4l8.4-8.4c1.9-1.9,1.9-5,0-6.9l0,0 c-0.9-0.9-2.1-1.4-3.4-1.4c0,0,0,0,0,0c-1.3,0-2.5,0.5-3.4,1.4l-1.1,1.1c-0.3,0.3-0.7,0.3-0.9,0l-1.1-1.1C9.5,4.1,8.3,3.7,7,3.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.b604e43c47e814c6de85ec4785532f2f.svg";
export { ForwardRef as ReactComponent };